import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FileStorageReturn } from '../models/file/file-storage';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FileStorageService {

  
  constructor(private httpClient: HttpClient) { }

  uploadFile(file: File): Observable<FileStorageReturn> {
    const formData: FormData = new FormData();
    formData.append('File', file);
    return this.httpClient.post<FileStorageReturn>(`${environment.api.url}/File`, formData);
  }

  getFileUrl(fileId: string): string{
    return fileId ? `${environment.api.url}/File/ViewFile/${fileId}` : 'assets/Images/no-image.jpg'
  }
}
